<template>
  <div class="container">
    <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="4000"
        no-hover-pause
        controls
        indicators
        img-width="200"
        img-height="200"

        style="text-shadow: 1px 1px 2px #333;"
    >
      <b-carousel-slide v-for="(image, index) in this.images" :key="index" :img-src="require(`../assets/` + image)"/>
    </b-carousel>
  </div>
</template>

<script>
export default {
name: "ProjectOverviewCarrousel",
  props:{
    images:{
      type: Array,
      default: ()=>["hc3p/HC3P_BannerCropped.jpg", "hc3p/HC3P_BannerCropped.jpg"]
    }
  },
  data() {
    return {
      slide: 0,
      sliding: null
    }
  }
}
</script>

<style scoped>

</style>